// extracted by mini-css-extract-plugin
module.exports = {"site":"SiteWasteRateChart_site__3ZFIT"};